export { default } from "./Card";
export type { CardProps } from "./Card";
